import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import { RoundedButton } from "@packages/ui";
import { Typography } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as appActions from "../../actions/appActions";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import * as rentalActions from "../../actions/rentalActions";

const RentalManageLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brand = getBrandFromUrl().toLowerCase();
  const loginState = useSelector((state) => state.rental.login);
  const extensionFlag = useSelector((state) => state.rental.extensionFlag || false);
  const eligibleFlag = useSelector((state) => state.rental.eligibleFlag || false);

  const logout = () => {
    dispatch(rentalActions.logout());
    dispatch(
      appActions.createToast({
        type: "success",
        message: "Logout success",
      })
    );
    navigate(`/rental/manage/login?brand=${brand}`);
  };

  return (
    <>
      <AppBar
        position="fixed" // Fix the navigation bar to the top
        color="transparent"
        style={{ zIndex: 100 }}
        elevation={0}
      >
        <Toolbar>
          <Grid
            justifyContent="space-between" // Add it here :)
            container
            spacing={8}
          >
            <Grid item>
              <Typography type="title" color="inherit"></Typography>
            </Grid>

            <Grid item>
              <div>
                {eligibleFlag && !extensionFlag && loginState === "success" && (
                  <RoundedButton onClick={logout}>Logout</RoundedButton>
                )}
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default RentalManageLogout;
